// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productQtyInfoStyles } from "@ces/App/Components/Product/ProductQtyInfo";
import TooltipIcon from "@ces/XDL/Icons/TooltipIcon";
import { xScreen } from "@ces/XDL/Utilities";
import { hideElementOnPrint } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

productQtyInfoStyles.wrapper = {
    css: css`
        display: flex;
        gap: 4px 16px;
        min-height: 15px;
        flex-wrap: wrap;
        position: relative;

        ${xScreen("lte", "sm")} {
            min-height: unset;
        }
        &:empty {
            display: none;
        }
    `,
};

const labelCss: InjectableCss = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        line-height: 15px;
        word-break: keep-all;
    `,
};

productQtyInfoStyles.minOrderedQtyWrapper = labelCss;

productQtyInfoStyles.multipleSaleQtyWrapper = labelCss;
productQtyInfoStyles.labelValue = {
    css: css`
        display: flex;
        column-gap: 4px;
    `,
};

productQtyInfoStyles.tooltip = {
    mergeCss: true,
    cssOverrides: {
        tooltipClickable: css`
            display: inline-flex;
            margin: 0;
            & ${IconWrapper}, & ${IconWrapper} > svg {
                height: 13px;
            }
        `,
        tooltipWrapper: css`
            display: inline-flex;
        `,
    },
    iconProps: {
        src: TooltipIcon,
        size: 12,

        css: css`
            opacity: 0.66;
            &:hover {
                opacity: 1;
            }
            ${hideElementOnPrint}
        `,
    },
};
